import BaseComponent from "../../../../baseComponent.js";

export default class FontOptions extends BaseComponent {
  constructor(props) {
    super(props);
    this.fonts = ["Roboto", "Arial", "Courier New", "Monospace", "sans-serif",
      "Times New Roman", "Trebuchet MS", "Verdana"];
    this.maxSize = 10;
    this.absoluteFontSize = [6, 7, 8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 82, 88, 94, 100, 115, 130, 150];
  }

  onValueClick(style, value) {
    this.props.onOptionValueClick(style, value);
  }

  showOptions(ref) {
    let element = this.refs[ref];
    this.props.onOptionClick(element);
  }

  render() {
    let fontFamilies = [];
    for (let i = 0; i < this.fonts.length; i++) {
      fontFamilies.push(<div className='item' key={i} style={{fontFamily: this.fonts[i]}}
                             onClick={() => this.onValueClick("fontFamily", this.fonts[i])}>{this.fonts[i]}</div>);
    }

    let fontSizes = [];
    if (this.props.fontSizeType === "Relative") {
      for (let i = 1; i <= this.maxSize; i++) {
        fontSizes.push(<div className="item" key={i} onClick={() => this.onValueClick("multiplier", i)}>x{i}</div>);
      }
    } else {
      fontSizes = this.absoluteFontSize.map((s,i) => {
        return <div className="item" key={i} onClick={() => this.onValueClick("multiplier", s)}>{s}</div>;
      });
    }

    let fontLabel = "";
    if (this.props.fontFamily) {
      fontLabel = this.props.fontFamily.length > 8 ?
        this.props.fontFamily.replace("'", "").substr(0, 7).trim() + ".." : this.props.fontFamily;
    }

    return (
      <div>
        <div className="tw-option-container">
          <div className="t-col" onClick={() => this.showOptions("fontFamilyOptions")}
               style={{flex: 1, textAlign: 'left', padding: '0 10px'}}>
            {fontLabel}
          </div>
          <div className="t-col" onClick={() => this.showOptions("fontSizeOptions")} style={{width: '60px'}}>
            {this.props.fontSizeType === "Relative" ? "x" : ""}{this.props.multiplier}
          </div>
          <div className="t-col" data-cat="style" onClick={() => this.onValueClick("bold", true)}
               style={{width: '40px', borderRight: 'none'}}>
            B
          </div>
        </div>
        <div className="option-list fonts font-selection-dropdown vertical-center" ref="fontFamilyOptions"
             style={{width: "168px", height: "140px", overflowY: "auto"}}>
          {fontFamilies}
        </div>
        <div className="option-list font-size multiplier-selection-dropdown vertical-center" ref="fontSizeOptions"
             style={{width: "168px", height: "140px", overflowY: "auto"}}>
          {fontSizes}
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/fontOptions.jsx